import { useScheduleEditorIds } from "./use-schedule-editor-ids"
import { readScheduleEditorSession } from "../lib/schedule-editor-session"

/** Immutable seed metadata for the current editing session. */
export function useScheduleEditorSeed() {
    const { draftId } = useScheduleEditorIds()
    const session = readScheduleEditorSession(draftId)

    return {
        seedSource: session?.seedSource,
        initialIsDraft: Boolean(session?.initialIsDraft),
        reviewCycle: session?.reviewCycle,
    }
}
